export default function LightOne() {
    return (
        <directionalLight
            castShadow
            intensity={0.2}
            position={[-5.4, 10.1, -4.6]}
            shadow-mapSize={[1024, 1024]}
        />
    )
}